import {
  IBranchDetail,
  IBranchDetailPersistence,
  IBranchListItem,
  IBranchPersistence,
  IBranchSelect,
  IBranchSelectPersistence,
  IBranchWithDeliveryPoint,
  IBranchWithDeliveryPointPersistence,
} from '../interfaces';

export class BranchMapper {
  public static toDomain(branch: IBranchPersistence): IBranchListItem {
    return {
      id: branch.id,
      name: branch.name,
      descr: branch.descr || '',
      address: branch.address || '',
      phone: branch.phone || '',
      email: branch.email || '',
      workinghours: branch.workinghours || '',
      isBranch: branch.is_branch === 1,
      isRegionBranch: branch.is_region_branch === 1,
      hide: branch.hide === 1,
      sortingLetter: branch.sorting_letter || '',
      latitude: branch.latitude || '',
      longitude: branch.longitude || '',
      mapUrl: branch.map_url || '',
      parent: branch.parent_id ? { id: branch.parent_id, name: branch.parent_branch_name || '' } : null,
      status: branch.state_id ? { id: branch.state_id, name: branch.state_name || '' } : null,
      company: branch.company_id ? { id: branch.company_id, name: branch.company_name || '' } : null,
      createdAt: branch.created_at || '',
    };
  }

  public static selectToDomain(branch: IBranchSelectPersistence): IBranchSelect {
    return {
      id: branch.id,
      name: branch.branch_name,
    };
  }

  public static detailToDomain(branch: IBranchDetailPersistence): IBranchDetail {
    return {
      ...BranchMapper.toDomain(branch),
      mapAddress: branch.map_address || '',
      openHour: branch.open_hour || '',
      closeHour: branch.close_hour || '',
      openHourSaturday: branch.open_hour_saturday || '',
      closeHourSaturday: branch.close_hour_saturday || '',
      cityName: branch.city_name || '',
      provinceName: branch.province_name || '',
      postCode: branch.post_code || '',
      warehouseMan: branch.warehouseman ? String(branch.warehouseman) : '',
    };
  }
}

export class BranchWithDeliveryPointMapper {
  public static toDomain(branch: IBranchWithDeliveryPointPersistence): IBranchWithDeliveryPoint {
    return {
      id: branch.id,
      name: branch.name,
      companyId: branch.company_id,
    };
  }
}
